import { useProductListParamsContext } from "@graphcommerce/magento-product";
import { Checkbox, FormControlLabel, Hidden, Switch, SwitchProps, styled } from "@mui/material"
import { useRouter } from "next/router";
import { createProductListLink } from "./ProductListLimit";

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 44,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 3,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#a5a5a5' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));
export default function FilterByStockStatus() {
  const { params } = useProductListParamsContext()



  const router = useRouter()

  function toProductListParams(params: any): any {
    const { sort, ...rest } = params
    return { sort: {}, ...rest }
  }
  const push = (params: any) => {
    const queryUrl = router.query.url ?? []
    const comingFromURLWithoutFilters = !queryUrl.includes('q')

    const path = createProductListLink(params)

    if (router.asPath === path) return false

    // push the first filter, so the new route (on browser back) will be e.g. /women/fruit instead of /women
    if (comingFromURLWithoutFilters) return router.push(path, path)
    return router.replace(path, path)
  }
  return (
    <FormControlLabel
      label="کالاهای موجود"
      classes={{
        label: "text-sm text-default-900 font-semibold ml-6 md:ml-0",
        root: "mt-3 md:mt-0 mr-[8px] md:mr-1"
      }}
      labelPlacement={window?.innerWidth < 992 ? "start" : "end"}
      control={
        <>
          <Hidden mdDown>
            <Checkbox
              color="info"
              size="small"
              sx={{

              }}
              checked={params.in_stock_only}
              onChange={e => {
                push({
                  ...toProductListParams({
                    ...params,

                    in_stock_only: Number(e.target.checked)
                  }), currentPage: 1
                })
              }}
            />
          </Hidden>
          <Hidden mdUp>
            <IOSSwitch
              color="primary"
              size="medium"
              sx={{

              }}
              checked={params.in_stock_only}
              onChange={e => {
                push({ ...toProductListParams({ ...params, in_stock_only: Number(e.target.checked) }), currentPage: 1 })
              }}
            />
          </Hidden>
        </>
      }
    />
  )
}